import request from '@/utils/request';
// 测试请求页
console.log(request, 'request');
export default {
  getTest: request('get', '/test'),
  getTestList: request('post', '/testList', {}),
};
